<template>
  <div>
    <van-row>
    <van-nav-bar title="审核情况" style="position:fixed;width: 100%;"  @click-left="onClickLeft" left-text="返回" left-arrow>
    </van-nav-bar>
    </van-row>
    <van-row style="margin-top:50px;background-color: white;">
      <van-cell title="申请:" :value="value"></van-cell>
    </van-row>
    <van-cell-group style="margin-top:5px;">
   <van-cell center :title="shr(item)"  :label="shyj(item)" v-for="item in list" size="large">
      <template #right-icon>

         <van-tag v-if="item.shzt==1 && item.lcyy==1" plain  type="primary" size="large">通过</van-tag>
         <van-tag v-if="item.shzt==0 && item.lcyy==1" plain  type="danger" size="large">驳回</van-tag>
          <van-tag v-if="item.lcyy==0 && item.isEnd != 1" plain color="#828476" size="large">未审</van-tag>
       </template>
     </van-cell>
     </van-cell-group>

  </div>
</template>

<script>
import {listSqmx} from '@/api/xm/shenhe.js'

export default {
  name: 'shlmxc',

  data () {
    return {
      list: [],
      value: null,
      total: 0,
      queryParams: {

        workid: null,
        codeid: null

      }
    }
  },
  // onLoad (option) {
  //   this.keywords = option.keywords
  // },
  created () {
    // const id  = this.$route.params && this.$route.params.bzId;
    console.log(this.$route)
    const workid = this.$route.query && this.$route.query.workid
    const codeid = this.$route.query && this.$route.query.codeid
    this.value = this.$route.query && this.$route.query.value
    this.queryParams.workid = workid
    this.queryParams.codeid = codeid
    this.getList()
  },
  activated () {

  },
  methods: {

    getList () {
      this.queryParams.pageNum += 1

      listSqmx(this.queryParams).then(res => {
        console.log(res)
        // this.finished = false
        this.list = res.data
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    shr (row) {
      if (row.ksr) {
        return '审核人：' + row.ksr
      }
      if (row.isEnd == 1) {
        return '流程结束！'
      }
    },
    shyj (row) {
      if (row.shyj) {
        return '审核意见：' + row.shyj
      }
    }
  }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ShenHe/shlmxc.vue